export default {
    prequal: {
        schema: {
            errorMessages: {
                loanAmount: 'Le montant du prêt doit être compris entre 2 000 $ et 35 000 $',
                loanPurpose: 'L’objet du prêt est requis',
                loanPurposeOther: 'Objet autre est requis',
                province: 'La province est requise',
                unsupportedProvince:
                    'Fig ne fonctionne actuellement pas dans les Territoires du Nord-Ouest, le Yukon et le Nunavut. Nous nous excusons pour le désagrément.',
                firstName: 'Le prénom légal est requis',
                lastName: 'Le nom de famille légal est requis',
                email: 'Adresse courriel invalide',
                emailTaken: 'Veuillez entrer une adresse courriel différente',
                dateOfBirth: 'La date de naissance est requise',
                dateOfBirthOutOfRange: 'Veuillez entrer une date de naissance valide',
                dateOfBirthUnderAge: 'Vous devez avoir au moins 18 ans pour appliquer avec Fig.',
                fullAddress: 'Veuillez entrer une adresse valide',
                poBoxNotAllowed: "Nous n'autorisons pas les boîtes postales",
                city: 'La ville est requise',
                postalCode: 'Le code postal est requis',
                postalCodeInvalid: 'Veuillez entrer un code postal canadien valide (p. ex., K1A 0A6)',
                phoneNumber: 'Veuillez entrer un numéro de téléphone canadien valide',
                phoneNumberTaken: 'Veuillez entrer un numéro de téléphone différent',
                employmentStatus: 'Le statut d’emploi est requis',
                occupationType: 'Le type d’occupation est requis',
                occupation: 'La profession est requise',
                jobTitle: 'Le titre du poste est requis',
                employerName: 'Le nom de l’employeur est requis',
                jobStartDate: 'La date de début d’emploi est requise',
                jobStartDateInvalid: 'Entrez un mois et une année de début valides (MM/AAAA)',
                annualIncome: 'Le revenu annuel doit être positif',
                annualIncomeBelowMinimum: 'Le revenu annuel doit être supérieur à 10 000 $',
                housingStatus: 'La situation de logement est requise',
                monthlyHousingPayment: 'Le loyer mensuel doit être positif',
                livedAtAddressSince: 'La date d’emménagement est requise',
                residencyStatus: 'Le statut de résidence est requis',
                levelOfEducation: 'Le niveau d’éducation est requis',
                loanInLastThreeMonths: 'Veuillez sélectionner une option',
                savingsAmount: 'Entrez un montant valide',
                vehicleOwnership: 'Veuillez sélectionner une option'
            }
        },
        loanamount: {
            title: 'Vérifiez votre taux en 1 minute !', // Check your rate in 1 minute!
            subtitle: 'Combien souhaitez-vous emprunter ?', // How much would you like to borrow?
            keyPointsSection: {
                title: 'Prêt personnel avec {{partner}} :', // Personal loan with Fig:
                point1: 'Processus de demande entièrement en ligne', // Fully digital application process
                point2: 'Fonds déposés en aussi peu que  1 jour ouvrable', // Funds deposited in as little as 1 business day
                point3: 'Aucun frais de remboursement anticipé' // No fees or prepayment penalties
            }
        },
        loanPurpose: {
            label: 'Objet du prêt', // Loan Purpose
            loanPurpose: 'Objet du prêt', // Loan Purpose
            DEBT_CONSOLIDATION: 'Consolidation de dettes', // Debt Consolidation
            EXPENSES: 'Dépenses', // Expenses
            HOME_IMPROVEMENT: 'Projets de rénovation', // Home Improvement
            EMERGENCY: 'Urgence', // Emergency
            AUTOMOBILE_FINANCING_OR_REPAIR: 'Financement automobile / réparations automobiles', // Automobile Financing / Repair
            EDUCATION: 'Éducation', // Education
            PERSONAL_INVESTMENT: 'Investissement personnel', // Personal Investment
            OTHER: 'Autre' // Other
        },
        loanPurposeOther: {
            label: 'Objet autre' // Other Purpose
        },
        aboutYourselfStep: {
            title: 'Parlez-nous de vous', // Tell us about yourself
            subtitle: 'Ceci nous aide à confirmer votre identité.', // This helps us confirm your identity
            firstName: {
                label: 'Prénom légal', // Legal first name
                placeholder: 'Prénom légal' // Legal first name
            },
            lastName: {
                label: 'Nom de famille légal', // Legal last name
                placeholder: 'Nom de famille légal' // Legal last name
            },
            legalNameHint:
                "Utilisez le nom exactement tel qu'il apparaît sur votre pièce d'identité émise par le gouvernement. Exemple : Jonathan (et non Jon)",
            email: {
                label: 'Adresse courriel', // Email address
                placeholder: 'Adresse courriel' // Email address
            },
            disclaimer: {
                text: "En continuant, vous consentez aux <0>Modalités et conditions</0> et à <1>l'énoncé de confidentialité</1> de Fig Financial Inc.", // By continuing, you agree to Fig Financial Inc's <0>Terms of Use</0> and <1>Privacy Statement</1>.
                title: 'Avis de confidentialité' // Privacy Notice
            },
            disclaimerQC:
                "En continuant, vous consentez à nos <0>Modalités et conditions</0>.<br/> En continuant, vous consentez à la collecte, à l'utilisation et au partage des informations que vous fournissez (ou que vous autorisez à fournir) pour traiter votre demande et vous fournir votre prêt conformément à notre <1>énoncé de confidentialité</1>.  Pour toute question concernant vos droits, le traitement de vos informations (y compris le traitement en dehors de votre province ou du Canada) ou le retrait de votre consentement, consultez notre Déclaration de confidentialité ou contactez notre responsable de la protection de la vie privée.",
            disclaimerQCContent: {
                content: `{{partner}} recueille, utilise et partage vos informations personnelles afin de :
-- start bullet points --
évaluer votre demande, y compris déterminer votre éligibilité pour un prêt en obtenant une vérification de crédit auprès d'une agence d’évaluation du crédit (avec votre consentement) ;

évaluer périodiquement votre éligibilité et votre solvabilité et déterminer si vous pouvez bénéficier de produits ou de services offerts par nous, nos affiliés, nos partenaires ou d'autres tiers sélectionnés ;

partager des informations avec des tiers (qui peuvent être situés en dehors de la juridiction dans laquelle vous vous trouvez), y compris nos affiliés ,fournisseurs de services, des agences d’évaluation du crédit, des agences de renseignement, et les références que vous fournissez dans cette demande ;

À moins que vous ne vous soyez désinscrit, partager de l’information avec nos sociétés affiliées pour qu’elles puissent vous contacter directement au sujet de leurs propres produits et services;

détecter et prévenir la fraude et les activités non autorisées, y compris l’utilisation par le partenaire tiers de {{partner}} chargé de la prévention des fraudes ;

recouvrir les dettes impayées liées à votre prêt ;

communiquer avec vous au sujet de votre prêt ; et

satisfaire aux exigences légales et réglementaires.
-- end bullet points --
Visitez notre <0>Énoncé de confidentialité</0> ou contactez-nous si vous avez des questions sur vos droits d'accéder, de rectifier ou de retirer votre consentement au traitement de vos informations personnelles; ou comment nous ou nos prestataires de services (y compris ceux en dehors de votre province ou du Canada) traitent vos informations personnelles.

Responsable de la protection de la vie privée
Fig Financial Inc.
630 boul. René Lévesque Ouest, Suite 1400
Montréal QC H3B 1S6
1-844-431-3444
privacy@fig.ca

`,
                closingParagraph:
                    "Visitez notre <0>Énoncé de confidentialité</0> ou contactez-nous si vous avez des questions sur vos droits d'accéder, de rectifier ou de retirer votre consentement au traitement de vos informations personnelles; ou comment nous ou nos prestataires de services (y compris ceux en dehors de votre province ou du Canada) traitent vos informations personnelles."
            },
            termsText: 'Modalités et conditions', // Terms of Use
            privacyText: 'Énoncé de confidentialité', // Privacy Statement
            termsLink: {
                fig: 'https://fig.ca/fr/legal/termes-et-conditions/',
                kizzo: 'https://kizzo.ca/fr/terms-and-conditions'
            },
            privacyLink: {
                fig: 'https://fig.ca/fr/legal/privacy-statement/',
                kizzo: 'https://kizzo.ca/fr/privacy-statement'
            }
        },
        personalInfoStep: {
            title: 'Encore quelques détails', // Just a few more details
            subtitle: 'Cela nous aide à confirmer votre identité', // This helps us confirm your identity
            dateOfBirth: {
                label: 'Date de naissance' // Date of Birth
            },
            phoneNumber: {
                label: 'Numéro de téléphone', // Phone Number
                placeholder: 'Numéro de téléphone' // Phone Number
            },
            address: {
                label: 'Adresse', // Address
                placeholder: 'Adresse', // Address
                autocompleteRequired:
                    'Veuillez sélectionner une adresse dans la liste. Vous ne la trouvez pas? Ajoutez votre ville (p. ex. 31 King St W Toronto), puis choisissez une suggestion.', // Please select from list; add city if not found
                incompleteSuggestion: "Cette suggestion n'inclut pas une province valide. Veuillez choisir une autre adresse dans la liste.", // Incomplete suggestion missing province
                lockedFieldsHint: 'Pour modifier la ville, la province ou le code postal, sélectionnez une autre adresse ci-dessus.' // To change city/province/postal, select a different address above
            },
            address2: {
                label: "Numéro d'unité (si applicable)", // Unit number (if applicable)
                placeholder: "Numéro d'unité (si applicable)" // Unit number (if applicable)
            },
            city: {
                label: 'Ville', // City
                placeholder: 'Ville' // City
            },
            province: {
                label: 'Province', // Province
                placeholder: 'Province' // Province
            },
            postalCode: {
                label: 'Code postal', // Postal Code
                placeholder: 'Code postal' // Postal Code
            },
            residencyStatus: {
                label: 'Statut de résidence au Canada', // Residency Status in Canada
                placeholder: 'Statut de résidence au Canada', // Residency Status in Canada
                CITIZEN: 'Citoyen', // Canadian citizen
                PERMANENT_RESIDENT: 'Résident permanent', // Permanent resident
                WORK_PERMIT: 'Permis de travail', // Work permit
                INTERNATIONAL_STUDENT: 'Étudiant international', // International student
                OTHER: 'Autre', // Other
                otherResidencyStatus: 'Autre statut' // Other Status
            }
        },
        provinces: {
            AB: 'Alberta',
            BC: 'Colombie-Britannique',
            MB: 'Manitoba',
            NB: 'Nouveau-Brunswick',
            NL: 'Terre-Neuve-et-Labrador',
            NS: 'Nouvelle-Écosse',
            NT: 'Territoires du Nord-Ouest',
            NU: 'Nunavut',
            ON: 'Ontario',
            PE: 'Île-du-Prince-Édouard',
            QC: 'Québec',
            SK: 'Saskatchewan',
            YT: 'Yukon'
        },
        employmentInfoStep: {
            title: "Quelle est votre statut d'emploi ?", // What's your employment status?
            subtitle:
                "Ceci nous aide à déterminer votre admissibilité. Il se peut que nous vérifions ces informations par la suite, essayez d'être le plus précis possible.", // This helps us determine your eligibility. We may verify this information later so try to be exact as possible.
            employmentStatus: {
                label: "Statut d'emploi", // Employment Status
                employmentStatus: "Statut d'emploi", // Employment Status
                FULL_TIME_EMPLOYED: 'Employé à temps plein',
                PART_TIME_EMPLOYED: 'Employé à temps partiel',
                SEASONAL_EMPLOYED: 'Employé saisonnier',
                SELF_EMPLOYED: 'Travailleur indépendant',
                UNEMPLOYED: 'Sans emploi/ au chômage',
                RETIRED: 'Retraité(e)',
                STUDENT: 'Étudiant',
                DISABILITY_OR_LONG_TERM_LEAVE: 'Invalidité / Congé de longue durée'
            },
            occupationType: {
                label: "Type d'occupation", // Occupation Type
                occupationType: "Type d'occupation", // Occupation Type
                informationTechnology: "Technologies de l'information et communications", // Information Technology and communications
                healthcare: 'Soins de santé et médecine', // Healthcare and medicine
                finance: 'Finance et banque', // Finance and banking
                education: 'Éducation', // Education
                retail: 'Vente au détail', // Retail
                manufacturing: 'Fabrication', // Manufacturing
                hospitality: 'Hospitalité et tourisme', // Hospitality and tourism
                construction: 'Construction', // Construction
                transportation: 'Transport', // Transportation
                other: 'Autre' // Other
            },
            jobTitle: {
                label: 'Titre du poste', // Job Title
                jobTitle: 'Titre du poste', // Job Title
                softwareEngineer: 'Ingénieur logiciel', // Software Engineer
                doctor: 'Médecin', // Doctor
                lawyer: 'Avocat', // Lawyer
                teacher: 'Enseignant', // Teacher
                retailManager: 'Gestionnaire de vente au détail', // Retail Manager
                manufacturingManager: 'Gestionnaire de fabrication', // Manufacturing Manager
                hospitalityManager: "Gestionnaire d'hospitalité", // Hospitality Manager
                constructionManager: 'Gestionnaire de construction', // Construction Manager
                transportationManager: 'Gestionnaire de transport', // Transportation Manager
                other: 'Autre' // Other
            },
            employerName: {
                label: 'Nom de l’employeur' // Employer Name
            },
            jobStartDate: {
                label: 'Date de début (MM/AAAA)' // Start Date (MM/YYYY)
            },
            annualIncome: {
                label: 'Revenu annuel',
                title: 'Indiquez-nous combien vous gagnez par an, avant impôts et déductions.',
                keyPointsSection: {
                    title: 'Veuillez inclure:',
                    point1: 'Votre salaire annuel de base et/ou vos revenus horaires',
                    point2: 'Vos gains à ce jour provenant de primes, commissions et rémunération variable',
                    point3: 'Vos revenus de retraite, d’invalidité, de pension ou d’aide sociale',
                    title2: 'N’incluez pas :',
                    point4: 'Le revenu du ménage'
                },
                highIncome: {
                    warning: 'Ce montant est inhabituellement élevé. Veuillez le confirmer ci-dessous.',
                    confirmPrompt: 'Votre revenu annuel est de <0>{{amount}}</0>. Est-ce exact?',
                    editAmount: 'Modifier le montant',
                    confirmButton: "Oui, c'est exact"
                }
            },
            levelOfEducation: {
                label: "Niveau d'éducation", // Level of Education
                HIGH_SCHOOL_OR_LESS: 'Études secondaires ou moins', // High School or Less
                SOME_COLLEGE: "Collège/ Diplôme d'associé", // Some College / Associate Degree
                BACHELORS: 'Baccalauréat (par ex., BA, BS)', // Bachelors Degree (e.g. BA, BS
                GRADUATE: 'Diplôme de deuxième ou troisième cycle ou professionnel (par exemple, Master, MBA, PhD, MD, JD) ', // Graduate or Professional Degree (e.g. MBA, PhD, MD,JD
                OTHER: 'Autre' // Other
            }
        },
        financialInfoStep: {
            title: 'Quelques questions financières rapides',
            subtitle: `Ceci nous aide à déterminer votre admissibilité. Il se peut que nous vérifions ces informations par la suite, essayez d’être le plus précis possible.`,
            loanRecent: {
                label: 'Avez-vous contracté un prêt au cours des 3 derniers mois ?',
                yes: 'Oui',
                no: 'Non'
            },
            savings: {
                label: 'Quel montant avez-vous en épargne ?',
                checkingPlaceholder: `Comptes chèques et comptes d'épargne`,
                investmentPlaceholder: 'Comptes d’investissement'
            },
            vehicle: {
                label: 'Possédez-vous actuellement un véhicule ?',
                options: {
                    FULLY_PAID: 'Oui, et il est entièrement payé',
                    LEASING: 'Oui, et je le loue actuellement',
                    ACTIVE_AUTO_LOAN: `Oui, et j'ai un prêt automobile en cours`,
                    NONE: 'Non, je ne possède pas de véhicule'
                }
            }
        },
        housingStatusStep: {
            title: 'Quelle est votre situation de logement ?', // What's your housing status?
            subtitle:
                "Cela nous aide à déterminer votre admissibilité. Il se peut que nous vérifions ces informations par la suite, essayez donc d'être le plus précis possible.", // This helps us determine your eligibility. We may verify this information later so try to be as exact as possible.
            housingStatus: {
                label: 'Situation', // Housing Status
                OWNED: 'Je suis propriétaire de mon logement', // I own my home
                RENTED: 'Je suis locataire', // I'm renting
                LIVING_WITH_FAMILY_OR_FRIENDS: 'Je vis chez des proches ou des amis' // I live with my family or friends
            },
            helpText: 'Dites-nous combien vous payez pour le loyer, l’hypothèque ou les autres dépenses liées au logement.',
            rentAmount: {
                label: 'Montant du loyer mensuel', // Monthly Rent Amount
                placeholder: 'Montant du loyer mensuel' // Monthly Rent Amount
            },
            mortgageAmount: {
                label: "Montant de l'hypothèque mensuelle", // Monthly Mortgage Amount
                placeholder: "Montant de l'hypothèque mensuelle" // Monthly Mortgage Amount
            },
            contributionAmount: {
                label: 'Dépenses mensuelles liées au logement', // Monthly Housing Contribution
                placeholder: 'Dépenses mensuelles liées au logement' // Monthly Housing Contribution
            },
            livingSince: {
                label: 'Vous résidez à cette adresse depuis (MM/AAAA)' // Lived here since (MM/YYYY)
            },
            disclaimer:
                'En cliquant sur « Obtenir mon offre », vous procéderez à une demande de prêt {{partner}}. Ceci entraînera une vérification de crédit non-enregistrée auprès de TransUnion, ce qui n’affectera pas votre cote de crédit.', // By clicking 'Get my offer' you are proceeding with a Fig loan application. This will result in a soft credit inquiry from TransUnion that will not affect your credit score.
            cta: {
                buttonText: 'Obtenir mon offre' // Get my offer
            }
        },
        offerStep: {
            title: 'Félicitations, ', // Congratulations,
            subtitle: "Vous êtes pré-qualifié pour un montant allant jusqu'à", // You're pre-qualified for up to
            stillHaveQuestions: 'Vous avez encore des questions ?',
            contactUs: 'Contactez-nous',
            offerExpiry: 'Offre expirant le {{date}}',
            monthlyPayment: {
                title: 'À partir de',
                description: 'Paiement mensuel',
                disclaimer: {
                    title: 'Paiement mensuel',
                    content:
                        'Le paiement mensuel indiqué est une estimation et peut légèrement différer du montant réel dû.<br/><br/> Fig ne facture aucuns frais en cas de remboursement anticipé. Si vous effectuez un paiement forfaitaire, votre paiement mensuel restera le même, mais vous rembourserez votre prêt plus rapidement que la durée initialement prévue.'
                }
            },
            promo: {
                message: 'Taux spécial pour vous, plus une chance de gagner 12 000 $ en prix !',
                alt: "Image d'offre promotionnelle"
            },
            quickFaq: {
                aprCalculated: {
                    title: 'Comment votre taux a-t-il été calculé ?',
                    content:
                        "Votre TAEG a été automatiquement généré par notre système en fonction de votre profil de crédit et d'autres facteurs financiers. Il est déterminé selon un processus standardisé et ne peut pas être négocié ni influencé par des échanges avec le service client."
                },
                fixedApr: {
                    title: 'Que signifie un TAP fixe garanti ?',
                    content:
                        "Fig ne pratique pas les offres trompeuses de type « bait-and-switch ». Cela signifie que le TAP fixe restera inchangé tout au long de votre demande et lors de la finalisation du prêt.\n\nLe Taux Annuel en Pourcentage (TAP) représente le coût total de l'emprunt sur une année, exprimé en pourcentage."
                },
                nextSteps: {
                    title: 'Étapes suivantes',
                    content:
                        "Maintenant que vous avez consulté votre offre, l'étape suivante est de compléter votre demande — cela ne prend que quelques minutes ! Pas d'appels, pas de paperasse, ni de déplacement en agence — tout se fait en ligne, depuis le confort de votre domicile. Une fois votre demande approuvée et votre prêt confirmé, vous recevrez les fonds sous 1 à 2 jours ouvrables."
                }
            },
            reviews: {
                title: 'Approuvé par des milliers de Canadiens satisfaits',
                anna: {
                    title: 'Une excellente nouveauté pour un processus toujours fastidieux',
                    content: 'Un processus simple, clair et efficace. Un taux incroyable sans frais cachés. Tout se fait en ligne, sans accroc.',
                    customer: 'Anna'
                },
                chun: {
                    title: 'La meilleure entreprise pour un prêt personnel !',
                    content:
                        "Une des meilleures entreprises financières avec lesquelles traiter. J'ai été préapprouvé. J'ai lié mon compte bancaire puis j'ai été approuvé instantanément. L'argent est arrivé 24 heures plus tard. Service extrêmement fluide et remarquable. Je continuerai à faire affaire avec cette entreprise pour mes besoins financiers futurs !",
                    customer: 'Chun'
                },
                carrie: {
                    title: "Cette entreprise m'a tellement aidée…",
                    content:
                        "Cette entreprise m'a aidée bien plus que je ne saurais l'exprimer, sans aucun jugement. Le processus de demande était simple et assez facile à suivre, avec une réponse rapide à ma demande. Merci, merci, merci ! Les remboursements sont également mis en place automatiquement, ce qui est d'une grande aide. Je recommanderais sans hésiter cette entreprise à toute personne dans le besoin.",
                    customer: 'Carrie'
                },
                customer: {
                    title: "Fig Financial a rendu tout le processus incroyablement fluide et adapté aux introvertis — et j'ai adoré ça…",
                    content:
                        "J'ai pu tout faire en ligne sans avoir besoin de parler directement à qui que ce soit, ce qui a été un vrai soulagement pour moi. La plateforme était claire, facile à naviguer, et m'a fourni exactement ce dont j'avais besoin, sans pression ni surcharge d'informations. En tant que personne qui apprécie la confidentialité et la simplicité, cette expérience a été exceptionnelle. Je me suis sentie autonome et bien informée à chaque étape. Si vous êtes comme moi et préférez gérer les choses calmement et efficacement, Fig Financial est une perle. Je recommande vivement.",
                    customer: 'Client(e)'
                },
                ramin: {
                    title: 'Attentionné',
                    content: "Tout est précis et clair selon le calendrier, et il n'y a aucune surprise.",
                    customer: 'Ramin'
                }
            },
            faq: {
                title: 'FAQ (Foire aux questions)',
                lineOfCredit: {
                    title: 'Est-ce une ligne de crédit ?',
                    content:
                        "Non, ce n'est pas une ligne de crédit. Fig propose des prêts personnels non garantis, ce qui signifie que vous recevez le montant total du prêt en une seule fois après approbation. Vous remboursez ensuite le prêt par des paiements fixes selon un calendrier établi. Cela diffère d'une ligne de crédit, où vous êtes approuvé pour une limite d'emprunt et pouvez retirer des fonds selon vos besoins, en payant des intérêts uniquement sur le montant utilisé."
                },
                fullAmount: {
                    title: 'Dois-je prendre la totalité du montant ?',
                    content:
                        "Pas du tout ! Vous êtes maître de votre choix — à l'écran suivant, vous pourrez sélectionner le montant de prêt qui vous convient, jusqu'à la limite pré-approuvée."
                },
                receiveFunds: {
                    title: 'Quand recevrai-je les fonds ?',
                    content:
                        'Une fois votre prêt confirmé et validé, vous recevrez un courriel de confirmation avec la date exacte de versement des fonds. Ceux-ci sont généralement déposés sur votre compte bancaire lié en 1 jour ouvrable, mais ce délai peut varier selon votre banque. Si vous ne recevez pas ce courriel de confirmation, veuillez nous contacter à support@fig.ca.'
                },
                payEarly: {
                    title: 'Puis-je rembourser mon prêt par anticipation ?',
                    content:
                        "Oui ! Vous pouvez effectuer des paiements supplémentaires manuellement ou rembourser votre prêt en totalité, en dehors des paiements programmés, sans frais supplémentaires directement depuis votre compte Fig. À mesure que votre solde diminue grâce à ces paiements, le montant de vos mensualités reste le même, mais la durée de votre prêt sera réduite et vous paierez moins d'intérêts au total."
                },
                creditScore: {
                    title: 'Est-ce que cela impacte ma cote de crédit ?',
                    content:
                        "Oui et non.\n\nLa consultation de votre offre est totalement gratuite et n'a aucun impact sur votre cote de crédit.\n\nLorsque vous avancez dans votre demande de prêt, nous utilisons également une vérification de crédit « douce » (soft credit check) pour évaluer votre admissibilité — cela n'affecte pas non plus votre cote de crédit.\n\nÀ la dernière étape du processus de demande, nous vous demanderons votre consentement pour effectuer une vérification de crédit « dure » (hard credit check). C'est le seul moment où votre cote de crédit pourrait être impactée — et uniquement si vous y consentez."
                },
                whoIsFig: {
                    title: 'Qui est Fig ?',
                    content:
                        "Fig est une filiale de Fairstone Bank of Canada, une banque de catégorie I réglementée au niveau fédéral.\n\nNous sommes une petite équipe de personnes bien réelles qui cherchent à rendre le secteur du prêt plus humain. Pour rester agile, nous avons fait le choix de ne pas avoir de bureau physique avec des horaires de 9 h à 17 h, et préférons collaborer avec Koru, un studio d'innovation appartenant au Régime de retraite des enseignantes et enseignants de l'Ontario, l'un des plus grands investisseurs mondiaux.\n\nDe plus, étant soutenus par Fairstone Bank, nous bénéficions d'une expertise de pointe dans le domaine du prêt, tout en proposant une approche flexible pour votre bien-être financier."
                }
            },
            preApproval: {
                disclaimer: {
                    title: 'Offre de prêt personnel préqualifiée.', // Pre-qualified personal loan offer.
                    content1:
                        "Une offre préqualifiée signifie que votre montant de prêt et votre taux d'intérêt sont verrouillés. Basé sur les informations que vous avez fournies, vous êtes préqualifié pour un montant allant jusqu'à {{loanAmount}} à un taux d'intérêt fixe de {{apr}}. Des détails supplémentaires peuvent être nécessaires pour finaliser votre approbation." // A pre-qualified offer means your loan amount and interest rate are locked in. Based on the information you've provided, you're pre-qualified for up to $35,000 at a fixed interest rate of 12.99%. Additional details may be needed to finalized your approval.
                }
            },
            keyPointsSection: {
                title: 'Quelle est la prochaine étape ?', // What's next?
                point1: 'Encore quelques étapes pour finaliser votre prêt', // Just a few more steps to finalize your loan
                point2: 'Fonds déposés en aussi peu que 1 jour ouvrable', // Funds deposited in as little as 1 business day
                point3: 'Remboursez à tout moment sans pénalités de remboursement anticipé' // Pay back anytime without prepayment penalties
            },
            loanAmount: {
                title: "Jusqu'à", // Up to
                description: 'Montant du prêt' // Loan Amount
            },
            apr: {
                title: 'Garanti à', // Guaranteed at
                description: 'TAP fixe', // Fixed APR
                disclaimer: {
                    title: 'TAP fixe', // Fixed APR
                    content:
                        'Fig ne croit pas aux offres trompeuses de type « appât et changement ». Cela signifie que le TAP fixe restera inchangé tout au long de votre demande et de la finalisation du prêt. Aucun frais caché supplémentaire', // Fig does not believe in misleading `bait-and-switch` offers. That means that the fixed APR will remain unchanged as you complete your application and finalize the loan. No additional hidden fees or charges.
                    content2: 'Le taux annuel en pourcentage (TAP) représente le coût total de l’emprunt sur un an, exprimé en pourcentage.' // The Annual Percentage Rate (APR) represents the total cost of borrowing over a year, expressed as a percentage.
                }
            },
            term: {
                title: "Jusqu'à", // Up to
                years: 'ans', // years
                description: 'Durée' // Term
            },
            disclaimer: {
                fullText:
                    "†Vous ne recevrez une offre de prêt et ne serez approuvé pour un prêt que si vous respectez les normes de crédit actuelles de Fig, qui incluent les conditions suivantes : vous n'avez pas actuellement de prêt Fig actif et vous n'avez pas été refusé par Fig au cours des 30 derniers jours. Toute approbation reçue est conditionnelle à l'examen standard de Fig qui peut inclure la vérification de (i) votre identité, (ii) les informations fournies dans le cadre de votre demande, et (iii) votre capacité de paiement. Les prêts Fig vont de 2 000 $ à 35 000 $ avec des termes de 24 à 60 mois. Les taux annuels en pourcentage (TAP) vont de 8,99 % à 29,49 %. Le TAP est identique au taux d'intérêt. Le montant de votre prêt et votre TAP dépendent de l'évaluation de votre profil de crédit. Le paiement mensuel et le coût total d'emprunt indiqués dans toute offre reçue sont des montants estimés et peuvent légèrement différer des montants réellement dus. L'offre exclut les résidents des Territoires du Nord-Ouest, du Nunavut et du Yukon. Recevez une carte-cadeau numérique Walmart de 50 $ pour les prêts personnels Fig entre 2 000 $ et 10 000 $ et une carte-cadeau numérique Walmart de 100 $ pour les prêts personnels Fig entre 10 001 $ et 35 000 $. Le prêt doit être actif et en règle après 90 jours (c'est-à-dire que tous les paiements de prêt doivent être effectués avec succès pendant les 90 premiers jours) pour recevoir la carte-cadeau numérique. Après le 90e jour, à condition que toutes les conditions de l'offre aient été remplies, une carte-cadeau numérique Walmart sera envoyée par courriel par Fig dans les cinq jours ouvrables, à l'adresse courriel utilisée dans la demande de prêt. Une limite d'une carte-cadeau numérique Walmart sera accordée par prêt éligible. Fig peut, à sa seule et absolue discrétion, modifier ou suspendre cette offre de carte-cadeau. Les cartes-cadeaux numériques Walmart reçues par erreur, y compris une erreur sur le montant émis, sont sujettes à annulation.",
                offerGuarantee: 'Cette offre est garantie pour 15 jours.' // This offer is guaranteed for 15 days.
            },
            cta: {
                buttonText: 'Obtenir mon prêt', // Get my loan
                applyLaterText: 'Demander plus tard' // Apply later
            },
            otpSection: {
                title: 'Pour continuer, veuillez entrer le code de vérification envoyé à votre adresse e-mail', // To continue, please enter the verification code sent to your email address
                textBelowOtpKizzo: 'Vous recevrez des courriels et des mises à jour de compte de Fig pour ce prêt.', // You'll receive emails and account updates from Fig for this loan.
                emailAddress: '{{emailAddress}}', // {{emailAddress}}
                verificationCode: 'Code de vérification', // Verification Code
                buttonText: 'Continuer', // Continue to get my loan
                changeEmail: 'Modifier', // Change
                newEmailAddress: 'Nouvelle adresse e-mail', // New Email Address
                save: 'Mettre à jour et renvoyer le code', // Save
                newEmailTitle: 'Entrez votre nouvelle adresse e-mail', // Enter your new email address
                verificationError: 'Code de vérification invalide. Veuillez vérifier votre code et réessayer.', // Invalid verification code. Please check your code and try again.
                emailUpdateError: "Échec de la mise à jour de l'adresse e-mail. Veuillez réessayer." // Failed to update email address. Please try again.
            },
            continueSection: {
                buttonText: 'Continuer' // Get my loan
            }
        },
        embeddedOfferStep: {
            subtitle: 'Vous êtes pré-qualifié pour une offre spéciale !'
        },
        kizzoOfferStep: {
            title: ',  vous êtes préqualifié pour un prêt Kizzo.',
            cta: {
                buttonText: 'Continuer avec Kizzo'
            },
            verificationCodeSection: {
                title: 'Entrez le code de vérification envoyé par Fig à votre adresse courriel.'
            }
        },
        figtoKizzoOfferStep: {
            subtitle: 'Un prêt Kizzo soutient un plus large éventail de profils de crédit, mais il est financé et administré par Fig.'
        },
        figTokizzoTooltip: {
            title: `Vous êtes préqualifié pour un prêt Kizzo.`,
            intro: `Le prêt Kizzo est un produit de prêt offert et administré par Fig Financial Inc. (« Fig »), conçu pour aider davantage de Canadiennes et Canadiens à accéder au crédit. Voici ce que cela signifie pour vous :`,
            point1: 'Votre prêt sera émis et administré par Fig.',
            point2: 'Tous les courriels, relevés et communications proviendront de Fig.',
            point3: 'Les dépôts du prêt apparaîtront dans votre compte bancaire au nom de Fig.',
            point4: 'Tous les paiements seront perçus par Fig.',
            gotIt: `J'ai compris`
        },
        kizzoToKizzoOfferStep: {
            subtitle: 'Vous êtes préqualifié pour un prêt de la Financière Kizzo, émis et géré par Fig.'
        },
        kizzoToKizzoTooltip: {
            title: `À propos de la Financière Fig`,
            intro: `Fig Financial Inc. (« Fig ») est le prêteur et l’administrateur de votre offre de prêt. Voici ce que cela signifie pour vous :`,
            point1: 'Votre prêt sera émis et administré par Fig.',
            point2: 'Tous les courriels, relevés et communications proviendront de Fig.',
            point3: 'Les dépôts du prêt apparaîtront dans votre compte bancaire au nom de Fig.',
            point4: 'Tous les paiements seront perçus par Fig.',
            gotIt: `J'ai compris`
        },
        kizzotoFigOfferStep: {
            title: 'Félicitations, ',
            subtitle: 'Vous êtes préqualifié pour un prêt Fig à un taux plus bas.',
            cta: {
                buttonText: 'Continuer avec Fig'
            }
        },
        kizzotoFigTooltip: {
            title: `Vous êtes préqualifié pour un prêt de la Financière Fig.`,
            intro: `Bonne nouvelle — votre profil de crédit vous permet d’être préqualifié pour un prêt directement auprès de Fig Financial Inc. (« Fig »). Voici ce que cela signifie pour vous :`,
            point1: 'Selon votre profil, vous êtes admissible à un prêt de Fig à un taux plus avantageux.',
            point2: 'Votre prêt sera émis et administré par Fig.',
            point3: 'Tous les courriels, relevés et communications proviendront de Fig.',
            point4: 'Les dépôts du prêt apparaîtront dans votre compte bancaire au nom de Fig.',
            point5: 'Tous les paiements seront perçus par Fig.',
            gotIt: `J'ai compris`
        },
        declinedStep: {
            generic: {
                title: "Désolé, nous ne sommes pas en mesure de vous offrir un prêt pour le moment. Soyez assuré que votre pointage de crédit n'a pas été affecté.", // Sorry, we aren't able to offer you a loan right now. Rest assured, your credit score was not affected.
                subtitle:
                    "Pour en savoir plus sur les raisons pour lesquelles vous n'avez peut-être pas été approuvé, vous pouvez visiter notre centre d'aide. Pour toute autre question et préoccupation, veuillez nous contacter via <0>le chat en direct Fig</0> en bas à droite de cette page ou par courriel au <1>support Fig</1>.", // To learn more about why you may not have been approved, you can visit our help centre. For any other questions and concerns, please reach out to us via <0>Fig live chat</0> to the bottom right of this page or email <1>Fig support</1>.
                buttonText: "Visiter le centre d'aide" // Visit help centre
            },
            region: {
                title: 'Désolé, nous ne sommes pas en mesure de vous offrir un prêt pour le moment.', // Sorry, we aren't able to offer you a loan right now.
                subtitle: "Fig n'opère actuellement pas dans les Territoires du Nord-Ouest, le Yukon et le Nunavut. Nous nous excusons pour le désagrément.", // Fig currently does not operate in Northwest Territories, Yukon and Nunavut. We apologize for the inconvenience.
                buttonText: "Aller à la page d'accueil" // Go to homepage
            },
            existingBorrower: {
                title: 'Vous avez déjà un prêt avec nous !', // You've already got a loan with us!
                subtitle:
                    "Visitez votre compte Fig pour les détails de votre prêt. Des questions ? Visitez notre centre d'aide pour obtenir les réponses dont vous avez besoin. Pour d'autres préoccupations, veuillez nous contacter via le chat en direct Fig en bas à droite de cette page ou par courriel au support Fig.", // Visit your Fig account for details of your loan. Got questions? Visit our help centre to get the answers you need. For other concerns please reach out to us via Fig live chat to the bottom right of this page or email Fig support.
                buttonText: 'Se connecter à mon compte Fig', // Log in to my Fig Account
                secondaryButtonText: "Visiter le centre d'aide" // Visit help centre
            },
            existingBorrowerRenewalEligible: {
                title: 'Vous avez déjà un prêt avec nous !', // You've already got a loan with us!
                subtitle:
                    "Visitez votre compte Fig pour les détails de votre prêt. Des questions ? Visitez notre centre d'aide pour obtenir les réponses dont vous avez besoin. Pour d'autres préoccupations, veuillez nous contacter via le chat en direct Fig en bas à droite de cette page ou par courriel au support Fig.", // Visit your Fig account for details of your loan. Got questions? Visit our help centre to get the answers you need. For other concerns please reach out to us via Fig live chat to the bottom right of this page or email Fig support.
                buttonText: 'Se connecter à mon compte Fig', // Log in to my Fig Account
                secondaryButtonText: 'Demander une augmentation du montant du prêt' // Request loan amount increase
            },
            mismatch: {
                title: "Désolé, nous n'avons pas pu confirmer votre identité en fonction des informations fournies.", // Sorry, we weren't able to confirm your identity based on the information provided.
                subtitle:
                    'Veuillez vérifier vos détails et réessayer. Pour toute autre question et préoccupation, veuillez nous contacter via le chat en direct Fig en bas à droite de cette page ou par courriel au support Fig.', // Please verify your details and try again. For any other questions and concerns, please reach out to us via Fig live chat to the bottom right of this page or email Fig support.
                buttonText: 'Réessayer' // Try again
            },
            tuNoHit: {
                title: "Il semble que nous ayons besoin d'un peu plus d'informations. Pouvez-vous fournir votre numéro d'assurance sociale ?", // Looks like we need a little more information. Can you provide your Social Insurance Number?
                subtitle:
                    "Votre nom et votre adresse seuls n'ont pas été suffisants pour nous confirmer que nous avions la bonne personne. Cela peut arriver si vous avez récemment déménagé ou changé de nom. Pour continuer, nous aurons besoin de votre numéro d'assurance sociale.", // Your name and address alone weren't enough for us to confirm that we had the right person. This can happen if you've recently moved or changed your name. To continue, we'll need your social insurance number.
                inputLabel: "Numéro d'assurance sociale (optionnel)", // Social Insurance Number (optional)
                buttonText: 'Obtenir mon offre' // Get my offer
            }
        }
    }
}
